import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLocationLogsCollection = GenericCollectionFactory("PMS_LOCATION_LOGS", "uid")